export default "__VITE_ASSET__CO1zaTT2__"